// TODO: double check HTMLInputElement once up and running
export function closeGroupDetails(template) {
    template.classList.remove("active");
    document.querySelector("body").classList.remove("stop-scrolling");
    template.id = "";
    template.querySelector(".title").innerHTML = "";
    template.querySelector(".group-stats").innerHTML = ``;
    template.querySelector(".group-email").value = "";
    template.querySelector(".individual-emails").value = "";
}
